/**
 * SummaryBox Component
 * Highlighted summary box with gradient background and primary border
 */

import React from 'react';
import { AnimatedContainer } from '../animations';

export interface SummaryBoxProps {
  text: string;
  icon?: string;
}

export const SummaryBox: React.FC<SummaryBoxProps> = ({ text, icon = '🌴' }) => {
  return (
    <AnimatedContainer animation="fadeSlideUp" duration={0.5}>
      <div className="ai360-summary-box">
        <div className="ai360-summary-box-content">
          {icon && (
            <span className="ai360-summary-box-icon" role="img" aria-label="summary icon">
              {icon}
            </span>
          )}
          <p className="ai360-summary-box-text">{text}</p>
        </div>
      </div>
    </AnimatedContainer>
  );
};
